
// Manrope will work in the browser, but then if the user downloads a SVG and tries to 
// embed it into an office doc then it will fall back to Arial.
const FONT_FAMILY = "Roboto, Arial"

export { FONT_FAMILY }
